import React, { useState } from 'react';
import { Users, Phone, Mail, Trash2, Edit2, Plus, Briefcase } from 'lucide-react';
import { api } from '../services/api';
import { useToast } from './Toast';

const ContractorDirectory = ({ contractors = [], projectId, onUpdate }) => {
    const { showToast } = useToast();
    const [editing, setEditing] = useState(null);
    const [formData, setFormData] = useState({ name: '', trade: '', phone: '', email: '', notes: '' });

    const handleSubmit = async () => {
        if (!formData.name) return;
        try {
            if (editing) {
                await api.updateContractor(editing.id, formData);
                showToast('Contractor Updated');
            } else {
                await api.addContractor(projectId, formData);
                showToast('Contractor Added');
            }
            onUpdate(); // Trigger refresh in App.js
            setEditing(null);
            setFormData({ name: '', trade: '', phone: '', email: '', notes: '' });
        } catch(e) { showToast('Error saving', 'error'); }
    };

    const handleEdit = (c) => {
        setEditing(c);
        setFormData(c);
    };

    const handleDelete = async (id) => {
        if(window.confirm('Delete contractor?')) {
            await api.deleteContractor(id);
            onUpdate();
        }
    };

    return (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
            <h3 className="text-xl font-bold mb-6 flex items-center gap-2"><Users className="text-blue-500"/> Sub-Contractors</h3>
            
            {/* FORM */}
            <div className="bg-blue-50 p-4 rounded-lg mb-6 border border-blue-100 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
                <input className="border rounded p-2" placeholder="Company/Name" value={formData.name} onChange={e=>setFormData({...formData, name: e.target.value})} />
                <input className="border rounded p-2" placeholder="Trade (e.g. Electrician)" value={formData.trade} onChange={e=>setFormData({...formData, trade: e.target.value})} />
                <input className="border rounded p-2" placeholder="Phone" value={formData.phone} onChange={e=>setFormData({...formData, phone: e.target.value})} />
                <input className="border rounded p-2" placeholder="Email" value={formData.email} onChange={e=>setFormData({...formData, email: e.target.value})} />
                <button onClick={handleSubmit} className="bg-blue-600 text-white rounded font-bold hover:bg-blue-700 flex items-center justify-center gap-2">
                    {editing ? <Edit2 size={16}/> : <Plus size={16}/>} {editing ? 'Update' : 'Add'}
                </button>
            </div>

            {/* LIST */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {contractors.map(c => (
                    <div key={c.id} className="border rounded-lg p-4 hover:shadow-md transition-shadow bg-white">
                        <div className="flex justify-between items-start mb-2">
                            <h4 className="font-bold text-gray-800">{c.name}</h4>
                            <div className="flex gap-2">
                                <button onClick={() => handleEdit(c)} className="text-gray-400 hover:text-blue-500"><Edit2 size={16}/></button>
                                <button onClick={() => handleDelete(c.id)} className="text-gray-400 hover:text-red-500"><Trash2 size={16}/></button>
                            </div>
                        </div>
                        <div className="space-y-1 text-sm text-gray-600">
                            <div className="flex items-center gap-2"><Briefcase size={14}/> <span className="bg-gray-100 px-2 rounded text-xs uppercase font-bold">{c.trade || 'General'}</span></div>
                            {c.phone && <div className="flex items-center gap-2"><Phone size={14}/> {c.phone}</div>}
                            {c.email && <div className="flex items-center gap-2"><Mail size={14}/> <a href={`mailto:${c.email}`} className="text-blue-600 hover:underline">{c.email}</a></div>}
                        </div>
                    </div>
                ))}
                {contractors.length === 0 && <div className="col-span-full text-center text-gray-400 py-10">No contractors added yet.</div>}
            </div>
        </div>
    );
};
export default ContractorDirectory;